<template>
  <i class="fas fa-project-diagram fa-2x"></i>
</template>

<script>
export default {};
</script>

<style>
</style>
